import { useCallback } from 'react';
import debounce from 'lodash/debounce';
import { useAnalytics } from '@medely/ui-kit';
import { useOTAMetadata } from '../useOTAMetadata';
import { useImpersonating } from '../useImpersonating';

const DEFAULT_DEBOUNCE_TIME = 500;

export type TrackNextStepCardsViewPayload = {
  cards: {
    position: number;
    card_name: string;
  }[];
};

export type TrackNextStepCardClickPayload = {
  position: number;
  card_name: string;
  button?: 'YES' | 'NO';
};

export function useNextStepTracking() {
  const analytics = useAnalytics();
  const otaMetadata = useOTAMetadata();
  const isImpersonating = useImpersonating();

  const trackNextStepCardsView = useCallback(
    debounce((payload: TrackNextStepCardsViewPayload) => {
      analytics.track({
        context: 'Today',
        subcontext: null,
        action: 'Viewed',
        cards: JSON.stringify(payload.cards),
        impersonating: isImpersonating,
        ...otaMetadata,
      });
    }, DEFAULT_DEBOUNCE_TIME),
    [analytics, isImpersonating],
  );

  const trackNextStepCardClick = useCallback(
    (payload: TrackNextStepCardClickPayload) => {
      analytics.track({
        context: 'Today',
        subcontext: 'Next Steps List Item',
        action: 'Clicked',
        ...payload,
        impersonating: isImpersonating,
        ...otaMetadata,
      });
    },
    [analytics, isImpersonating],
  );

  return {
    trackNextStepCardsView,
    trackNextStepCardClick,
  };
}

export default useNextStepTracking;
